module.exports = __webpack_public_path__ + "img/check_circle.05062fde.svg";